import { render, staticRenderFns } from "./DeudaShow.vue?vue&type=template&id=b9c71bfa"
import script from "./DeudaShow.vue?vue&type=script&lang=js"
export * from "./DeudaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports